import { StyleSheet } from 'react-native'

export const ThemedLoaderStyles = StyleSheet.create({
	themedBlock: {
		alignItems: 'center'
	},
	text: {
		margin: 20
	}
})